import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/functions";
import "firebase/database";
import "firebase/storage";

import firebaseConfig from "../../firebaseConfig";

export default function initFirebase() {
  firebase.initializeApp(firebaseConfig);
}
